import React, { Component } from 'react'
import { graphql, withApollo, compose } from 'react-apollo'
import { observer, inject } from 'mobx-react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { Modal, Form, Button, Select, Input, Tag, Row, Col, Radio, Icon, Tooltip } from 'antd'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
import _groupBy from 'lodash/groupBy'
import _flatten from 'lodash/flatten'
import moment from 'moment'
import leftPad from 'left-pad'
import provinces from '~/data/provinces'
import nationalities from '~/data/nationalities'
import countries from '~/data/countries'
import bloodTypes from '~/data/bloodTypes'
import renderQuestionInput from '~/renderQuestionInput'

import registrationQuery from '~/App/graphql/queries/registration.gql'
import currentUserQuery from '~/App/graphql/queries/currentUser.gql'
import participantQuery from '~/App/graphql/queries/participant.gql'
import verifyTicketNumberQuery from '~/App/graphql/queries/verifyTicketNumber'
import verifyCouponCodeQuery from '~/App/graphql/queries/verifyCouponCode'
import createParticipantMutation from '~/App/graphql/mutations/createParticipant.gql'
import updateParticipantMutation from '~/App/graphql/mutations/updateParticipant.gql'

import getAgeCategory from '~/App/utils/getAgeCategory'
import getRaceDayAge from '~/App/utils/getRaceDayAge'
// import getRaceYearAge from

import DatePickerDropDown from '../../components/DatePickerDropDown'
import './styles.css'

const inputCols = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}

class ParticipantEditModal extends Component {
  submitting = false
  // state = {
  //   submitting: false
  // }
  ageCategoryString = ({ category, gender }) => {
    const g = gender ? gender[0].toUpperCase() : ''
    if (!category) {
      return <FormattedMessage id="app.ageCategories.open" />
    }
    const { min, max } = category
    if (!min && max) {
      return <FormattedMessage id="app.ageCategories.under" values={{ gender: g, upper: max + 1 }} />
      // return `${g} under ${max + 1}`
    } else if (min && !max) {
      return <FormattedMessage id="app.ageCategories.over" values={{ gender: g, lower: min }} />
      // return `${g} ${min} up`
    } else {
      return <FormattedMessage id="app.ageCategories.between" values={{ gender: g, lower: min, upper: max }} />
      // return `${g} ${min} - ${max}`
    }
  }
  reservedNumberValidator = (rule, value, callback) => {
    // console.log('this.props', this.props)
    const {
      // form: { getFieldValue, setFieldsValue, resetFields },
      client,
      event: { _id: eventId }
    } = this.props

    // console.log({ rule, value })
    if (!value) return callback()
    client
      .query({
        query: verifyTicketNumberQuery,
        fetchPolicy: 'network-only',
        variables: {
          number: Number.parseInt(value, 10),
          eventId
        }
      })
      .then(({ data }) => {
        const { checkTicketNumber } = data
        checkTicketNumber ? callback() : callback('number not available')
      })
  }
  couponCodeValidator = (rule, value, callback) => {
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log({ rule, value })
    const { i18n: { locale } } = this.props
    if (!value) return callback()
    const { fullField } = rule
    const [, groupIndex] = fullField.split('.')
    const {
      form: { getFieldValue, setFieldsValue, resetFields },
      client,
      event: { _id: eventId, ticketTypes }
    } = this.props

    client
      .query({
        query: verifyCouponCodeQuery,
        fetchPolicy: 'network-only',
        variables: {
          code: value,
          eventId
        }
      })
      .then(
        ({ data: { verifyCouponCode } }) => {
          // console.log({verifyCouponCode})
          const ticketTypeId = getFieldValue(
            `tickets[${groupIndex}].productTypeId`
          )
          const { _id, couponCodeType: { productTypeIds } } = verifyCouponCode
          // console.log(productTypeIds, ticketTypeId)
          const ticketType = ticketTypes.find(tt => tt._id === ticketTypeId)
          if (productTypeIds.includes(ticketTypeId)) {
            callback()
            setFieldsValue({
              [`tickets[${groupIndex}].__couponCodeInfo`]: (
                <span>
                  <Icon type="check-circle" /> code <em>{value}</em> applied for{' '}
                  {ticketType.name[locale]}
                </span>
              ),
              [`tickets[${groupIndex}].couponCodeId`]: _id
            })
          } else {
            const message = 'Incorrect ticket type'
            callback(message)
          }
        },
        e => {
          // console.dir(e)
          if (e.graphQLErrors) {
            resetFields([`tickets[${groupIndex}].__couponCodeInfo`])
            // e.graphQLErrors.forEach(error => callback(error.message))
            callback(e.graphQLErrors)
          } else {
            callback()
          }
          // message.error(e.message)
        }
      )
  }

  dateValidator = (rule, value, callback) => {
    const { intl } = this.props
    const $message = intl.formatMessage({
      id: 'app.invalidDate',
      defaultMessage: 'Invalid Date'
    })
    moment(value).isValid() ? callback() : callback($message)
  }

  genderValidator = (rule, value, callback) => {
    const { registration, participantId, intl } = this.props
    const editMode = !!participantId && (participantId !== 'new')
    // const { editMode } = this.state
    const registrationType = _get(registration, 'registrationType')
    const restrictions = _get(registration, 'registrationType.restrictions', [])
    const participants = _get(registration, 'participants', [])
    // console.log({ restrictions })
    if (restrictions.includes('gender_mix')) {
      const genders = participants.map(p => _get(p, 'profile.gender'))
      if (editMode) genders.push(value)
      if (genders.length === registrationType.maxParticipants &&
        (!genders.includes('male') || !genders.includes('female'))
      ) {
        const $message = intl.formatMessage({
          id: 'app.genderMixError',
          defaultMessage: 'Group should contain both male and female participants'
        })
        return callback($message)
      }
      callback()
    } else if (restrictions.includes('gender_male') && value !== 'male') {
      const $message = intl.formatMessage({
        id: 'app.genderMaleOnlyError',
        defaultMessage: 'Only male participants allowed'
      })
      callback($message)
    } else if (restrictions.includes('gender_female') && value !== 'female') {
      const $message = intl.formatMessage({
        id: 'app.genderFemaleOnlyError',
        defaultMessage: 'Only female participants allowed'
      })
      callback($message)
    }
    callback()
  }

  birthDateValidator = (rule, value, callback) => {
    // const { fullField } = rule
    // const [, groupIndex] = fullField.split('.')
    const {
      form: { getFieldValue, resetFields },
      event: { ticketTypes },
      // registration: { registrationType },
      intl
    } = this.props

    // const ticketTypeId = getFieldValue(
    //   `tickets[${groupIndex}].productTypeId`
    // )
    // console.log({ registrationType })
    const tickets = getFieldValue('tickets', [])
    // console.log({ tickets })
    const gender = getFieldValue('profile.gender')
    // console.log({ tickets })
    let errors = 0
    // console.log('validation')
    tickets.forEach((ticket, groupIndex) => {
      const { productTypeId } = ticket
      const ticketType = ticketTypes.find(tt => tt._id === productTypeId)
      if (ticketType) {
        const race = _get(ticketType, 'race')
        // console.log({ race, ticketType })
        // ASICS coditions
        const ageRange = _get(ticketType, 'race.ageRangeStrict')
        if (ageRange) {
          // const ageRange = _get(ticketType, 'race.ageRangeStrict')
          const age = getRaceDayAge({ race, birthDate: value })
          // console.log({ ticketType })
          const strictMinAge = _get(ageRange, [gender, 'min'])
          const strictMaxAge = _get(ageRange, [gender, 'max'])

          if (strictMinAge && age < strictMinAge) {
            errors++
            return callback(intl.formatMessage({
              id: 'app.minAgeNotice',
              defaultMessage: 'Participants should be at least {strictMinAge} years of age on race day'
            }, {
              strictMinAge
            }))
          }
          if (strictMaxAge && age > strictMaxAge) {
            errors++
            return callback(intl.formatMessage({
              id: 'app.maxAgeNotice',
              defaultMessage: 'Participants should be at most {strictMaxAge} years of age on race day'
            }, {
              strictMaxAge
            }))
          }
        }
        if (ticketType.ageCategoryIds && ticketType.ageCategoryIds.length) {
          // const allowedCategories = _get(race, 'ageCategories', []).filter(cat => ticketType.ageCategoryIds.includes(cat._id))
          const ageCategory = getAgeCategory({ race, birthDate: value, gender })
          const catId = _get(ageCategory, 'category._id')
          if (!catId || !ticketType.ageCategoryIds.includes(catId)) {
            resetFields([`tickets[${groupIndex}].productTypeId`])
            // errors++
            // return callback(intl.formatMessage({
            //   id: 'app.invalidAge',
            //   defaultMessage: 'Invalid age'
            // }))
          }
          // console.log({ allowedCategories, ageCategory })
        }

        // KK10 conditions
        // const yearAge - get
        // console.log(ticketType.race.ageCategories)
      }
    })
    if (!errors) {
      callback()
    }
  }

  emailValidator = (rule, value, callback) => {
    const { participantId, registration, intl } = this.props

    // const { editMode } = this.state
    const participants = _get(registration, 'participants', [])
    const participantUniqueEmail = _get(registration, 'event.settings.participant.uniqueEmail')
    // console.log({ restrictions })
    if (participantUniqueEmail) {
      const emails = participants.filter(p => p._id !== participantId).map(p => _get(p, 'profile.email'))
      if (emails.includes(value)) {
        return callback(intl.formatMessage({
          id: 'app.participantEmailUnique',
          defaultMessage: 'Each participant should have unique email'
        }))
      }
    }
    callback()
  }

  handleCouponCodeTextChange = ({ groupIndex }) => e => {
    const { resetFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    resetFields([
      `tickets[${groupIndex}].couponCodeId`
    ])
  }

  checkCouponCode = ({ groupIndex }) => {
    const { validateFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    validateFields(
      [
        `tickets[${groupIndex}].couponCodeText`
      ],
      { force: true }
    )
  }

  onClose = e => {
    const { registration, history } = this.props
    history.push(`/reg/${registration._id}/edit`)
  }

  componentWillReceiveProps (nextProps, nextState) {
    // const { participantId } = nextProps
    // const editMode = !!participantId && (participantId !== 'new')
    // console.log({ editMode })
  }

  render () {
    const {
      event,
      registration,
      participantId,
      form,
      data,
      createParticipant,
      updateParticipant,
      i18n: { locale },
      visible,
      intl
      // onClose
    } = this.props
    const { registrationType } = registration
    const restrictions = _get(registrationType, 'restrictions', [])
    const {
      getFieldDecorator,
      getFieldValue,
      validateFields,
      setFieldsValue,
      resetFields
    } = form
    const { currentUser } = this.props.client.readQuery({
      query: currentUserQuery
    })
    const {
      _id,
      ...user
    } = currentUser

    const newParticipant = {
      ...user,
      profile: {
        ...currentUser.profile,
        firstName: '',
        lastName: '',
        email: currentUser.email
      }
    }
    const editMode = !!participantId && participantId !== 'new'
    // const { editMode } = this.state
    const participant = editMode ? _get(data, 'participant') : newParticipant
    // console.log({ participant })
    if (!participant) {
      return <div>Loading...</div>
    }

    const couponCodes = _get(registration, 'couponCodes', [])
    const codeTicketTypeIds = _flatten(couponCodes.map(cc => _get(cc, 'couponCodeType.ticketTypeIds', [])))
    // const { l: locale = 'en' } = queryString.parse(location.search)
    const ticketTypeIds = _get(registration, 'registrationType.ticketTypeIds', [])
    // console.log({ ticketTypeIds })
    const participantFields =
      _get(event, 'settings.participant.fields', []) || []

    const periods = _get(event, 'periods')
    const currentPeriodIds = periods.filter(period =>
      moment().isBetween(period.start, period.end) || moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
    ).map(p => p._id)
    const ticketTypes = _get(event, 'ticketTypes', [])
      .filter(tt => ticketTypeIds.includes(tt._id))
      .filter(tt => {
        if (registrationType.hidden) return true
        if (codeTicketTypeIds.length > 0) return codeTicketTypeIds.includes(tt._id)
        return currentPeriodIds.includes(tt.periodId)
      }) // TODO: should move period to registration
    const tickets = _get(participant, 'tickets', [])
    const shirtTypes = _get(event, 'shirtTypes', [])
    const shirtCounts = _get(event, 'shirtCounts', [])
    // getFieldDecorator('tickets', {
    //   initialValue: tickets
    // })
    // console.log('tick', getFieldValue('tickets'))
    // const shirts = _get(event, 'shirts', []).map(shirt => ({
    //   ...shirtCounts.find(s => s._id === shirt._id),
    //   ...shirt
    // }))
    const regFields = participantFields
      .filter(f => f.enabled)
      .reduce((result, field) => {
        result[field.name] = field
        return result
      }, {})
    // const mode = participantId ? 'edit' : 'new' // TODO: enum / Symbol
    // console.log({ editMode, participantId })
    if (editMode) {
      getFieldDecorator('_id', {
        initialValue: participantId
      })
    }
    event && getFieldDecorator('eventId', { initialValue: _get(event, '_id') })
    registration && getFieldDecorator('registrationId', { initialValue: _get(registration, '_id') })
    registration && getFieldDecorator('order', {
      initialValue: _get(participant, 'order', _get(registration, 'participants', []).length)
    })
    const participantOrder = getFieldValue('order') + 1
    // console.log({ participantOrder })
    const handleSubmit = e => {
      e.preventDefault()
      // console.log('submit', { validateFields })
      validateFields({ force: true }, (err, record) => {
        if (!err) {
          // console.log('submitting', this.submitting)
          // console.log({ record })
          if (!this.submitting) {
            this.submitting = true
            // this.setState(({ submitting }) => ({ submitting: true }))
            if (editMode) {
              updateParticipant({
                variables: { record },
                refetchQueries: [{ // can use updateQuery
                  query: registrationQuery,
                  variables: {
                    _id: record.registrationId
                  }
                }]
              }).then(res => {
                // this.setState({ submitting: false })
                this.props.history.push(
                  `/reg/${registration._id}/edit`
                )
                // this.submitting = false
              })
            } else {
              createParticipant({
                variables: { record },
                refetchQueries: [{ // can use updateQuery
                  query: registrationQuery,
                  variables: {
                    _id: record.registrationId
                  }
                }]
              }).then(res => {
                // this.setState({ submitting: false })
                this.props.history.push(
                  `/reg/${registration._id}/edit`
                )
                // this.submitting = false
              }).catch(err => {
                console.error(err)
                this.submitting = false
              }) // TODO: show alert
            }
          }
        }
        // console.error(err)
      })
    }
    const requiredFieldMessage = intl.formatMessage({
      id: 'app.requiredFieldMessage',
      defaultMessage: 'This field is required'
    })
    const birthDateDecorator = getFieldDecorator(`profile.birthDate`, {
      initialValue: _get(participant, 'profile.birthDate') || moment().subtract({ years: 20 }).toISOString(),
      rules: [{ validator: this.dateValidator }, {
        validator: this.birthDateValidator
      }]
    })
    const genderDecorator = getFieldDecorator(`profile.gender`, {
      initialValue: _get(participant, 'profile.gender'),
      rules: [{
        required: true,
        message: requiredFieldMessage
      }, {
        validator: this.genderValidator
      }]
    })
    const taxInvoiceTypeDecorator = getFieldDecorator(
      `profile.taxInvoice.type`,
      {
        initialValue: _get(participant, 'profile.taxInvoice.type', 'none'),
        rules: [{
          required: _get(regFields, 'taxInvoice.required'),
          message: intl.formatMessage({
            id: 'app.taxInvoiceTypeRequired',
            defaultMessage: 'Tax Invoice Type Required'
          })
        }]
      }
    )
    const getRules = (field) => {
      const rules = []
      if (!field) {
        return rules
      }
      if (field.required) {
        rules.push({
          required: true,
          message: requiredFieldMessage
        })
      }
      if (field.validations) {
        field.validations.forEach(validation => {
          switch (validation.type) {
            case 'pattern': return rules.push({
              pattern: new RegExp(validation.params[0]),
              message: validation.message[locale]
            })
            default:
          }
        })
      }
      return rules
    }
    const taxInvoiceType = getFieldValue(`profile.taxInvoice.type`)
    const birthDate = getFieldValue(`profile.birthDate`)
    const gender = getFieldValue(`profile.gender`)

    const ticketTypeAgeFilter = (ticketType) => {
      const ageCategoryIds = _get(ticketType, 'ageCategoryIds', [])
      if (ageCategoryIds.length > 0) {
        const ageCategory = getAgeCategory({ race: ticketType.race, birthDate, gender })
        const catId = _get(ageCategory, 'category._id')
        return ageCategoryIds.includes(catId)
      }
      return true
    }
    // console.log({ currentPeriods })
    // const isPreRegister = currentPeriod && moment().isBetween(currentPeriod.preRegisterStart, currentPeriod.preRegisterEnd)
    // console.log({ isPreRegister })
    const ticketTypePeriodFilter = (ticketType) => {
      return true
      // return currentPeriods.map(p => p._id).includes(ticketType.periodId) // || isPreRegister
    }

    const ticketGroups = _groupBy(ticketTypes, 'group')
    const $ticketGroups = Object.keys(ticketGroups).map((group, groupIndex) => {
      const ticket = _get(tickets, groupIndex, {})
      // console.log({ ticket })
      if (editMode) {
        getFieldDecorator(`tickets[${groupIndex}]._id`, {
          initialValue: _get(ticket, '_id')
        })
      }
      const ticketTypeDecorator = getFieldDecorator(
        `tickets[${groupIndex}].productTypeId`,
        {
          initialValue: _get(ticket, 'productTypeId'), // || _get(ticketTypes, [0, '_id']),
          rules: [{ required: true, message: 'Please select ticket type' }]
        }
      )
      // const ticketTypeDecorator = getFieldDecorator(`tickets[${groupIndex}].productTypeId`, { exclusive: true })
      const ticketTypeId = getFieldValue(`tickets[${groupIndex}].productTypeId`)
      // console.log({ ticketTypeId }, _get(ticket, 'ticketType._id'))
      const selectedTicketType = ticketTypes.find(
        ticketType => ticketType._id === ticketTypeId
      )
      const questions = _sortBy(
        _get(event, 'ticketQuestions', []).concat(
          _get(selectedTicketType, 'questions', [])
        ),
        ['order']
      )
      const shirtEnabled = _get(selectedTicketType, 'shirtEnabled', false)
      const ticketTypeIdCount = _get(event, 'ticketTypeCount')
      // const ticketTypeCount = ticketTypeIdCount.map(({ _id }) => )
      // const resetTicketType = () => {
      //   resetFields([`tickets[${groupIndex}].ticketTypeId`])
      // }
      const resetQuestions = (ticketTypeId) => {
        const selectedTicketType = ticketTypes.find(
          ticketType => ticketType._id === ticketTypeId
        )
        const shirtEnabled = _get(selectedTicketType, 'shirtEnabled', false)
        resetFields([
          // `tickets[${groupIndex}].couponCodeText`,
          `tickets[${groupIndex}].shirtTypeId`,
          `tickets[${groupIndex}].shirtId`,
          `tickets[${groupIndex}].__couponCodeInfo`,
          ...questions.map((question, questionIndex) => {
            const optionField = {
              Open: 'value',
              Choice: 'itemId',
              MultiChoice: 'itemIds'
            }[question.kind]
            return `tickets[${groupIndex}].options[${questionIndex}].${optionField}`
          })
        ])
        if (!shirtEnabled) {
          setFieldsValue({
            [`tickets[${groupIndex}].shirtTypeId`]: null,
            [`tickets[${groupIndex}].shirtId`]: null
          })
        }
      }
      const $ticketQuestions = questions.map((question, questionIndex) => {
        // getFieldDecorator(`tickets[${groupIndex}].options`, {
        //   initialValue: []
        // })

        // getFieldDecorator(`tickets[${groupIndex}].options[${questionIndex}]`, {
        //   initialValue: {}
        // })

        if (editMode) {
          getFieldDecorator(
            `tickets[${groupIndex}].options[${questionIndex}]._id`,
            {
              initialValue: _get(ticket, `options[${questionIndex}]._id`)
            }
          )
        }
        // console.log({ qId: question._id })
        getFieldDecorator(
          `tickets[${groupIndex}].options[${questionIndex}].questionId`,
          {
            initialValue: question._id
          }
        )

        const optionField = {
          Open: 'value',
          Choice: 'itemId',
          MultiChoice: 'itemIds'
        }[question.kind]
        const optionValidator = (rule, value, callback) => {
          // TODO: separate to utils
          if (question.opts && question.opts.validator) {
            const { validator } = question.opts
            let valid = true
            if (value) {
              if (validator.itemCount) {
                if (
                  validator.itemCount.min &&
                  value.length < validator.itemCount.min
                ) {
                  valid = false
                }
                if (
                  validator.itemCount.max &&
                  value.length > validator.itemCount.max
                ) {
                  valid = false
                }
                if (!valid) {
                  const message = `must be between ${validator.itemCount.min} and ${validator.itemCount.max} items`
                  return callback(message)
                }
              }
              // console.log(validator, value)
              if (validator.min && value < validator.min) {
                valid = false
              }
              if (validator.max && value > validator.max) {
                valid = false
              }
              if (!valid) {
                const message = `must be between ${validator.min} and ${validator.max}`
                return callback(message)
              }
            } else {
              valid = false
            }
          }
          callback()
        }
        const questionRules = [{ validator: optionValidator }]
        questionRules.push({ required: question.required, message: `${question.name[locale]} is Required` })
        // console.log({ticket})
        const optionDecorator = getFieldDecorator(
          `tickets[${groupIndex}].options[${questionIndex}].${optionField}`,
          {
            initialValue: _get(
              ticket,
              `options[${questionIndex}].${optionField}`
            ) || question.default,
            rules: questionRules
          }
        )
        return (
          <Form.Item
            label={
              <span>
                {question.name[locale]}
                {question.infoMessage &&
                  <Tooltip title={_get(question, ['infoMessage', locale])} placement="rightBottom">
                    &nbsp;<Icon type="question-circle-o" style={{ fontSize: 'large' }} />
                  </Tooltip>
                }
              </span>
            }
            {...inputCols}
            key={questionIndex}
          >
            {optionDecorator(renderQuestionInput({ question, locale }))}
          </Form.Item>
        )
      })
      let $shirtTypes, shirtTypeId, $shirts
      if (shirtTypes.length > 0) {
        $shirtTypes = (
          <Form.Item
            label={<FormattedMessage id="app.shirtType" defaultMessage="Shirt Type" />}
            {...inputCols}
          >
            {getFieldDecorator(`tickets[${groupIndex}].shirtTypeId`, {
              initialValue: shirtEnabled ? _get(ticket, 'shirtTypeId') || _get(shirtTypes, [0, '_id']) : null,
              rules: [{
                required: shirtEnabled,
                message: requiredFieldMessage
              }]
            })(
              <Radio.Group>
                {shirtTypes.map(type =>
                  <Radio key={type._id} value={type._id}>
                    {type.name[locale]}
                  </Radio>
                )}
              </Radio.Group>
            )}
          </Form.Item>
        )
        shirtTypeId = getFieldValue(`tickets[${groupIndex}].shirtTypeId`)
        const shirtIds = _get(selectedTicketType, 'shirtIds', [])
        $shirts = (
          <Form.Item
            label={<FormattedMessage id="app.shirtSize" defaultMessage="Shirt Size" />}
            {...inputCols}
          >
            {getFieldDecorator(`tickets[${groupIndex}].shirtId`, {
              initialValue: shirtEnabled ? _get(ticket, 'shirtId') : null,
              rules: [{
                required: shirtEnabled,
                message: requiredFieldMessage
              }]
            })(
              <Select getPopupContainer={() => this.modalRef}>
                {shirtCounts.filter(s => s.shirtTypeId === shirtTypeId && ((shirtIds.length > 0 && shirtIds.includes(s._id)) || shirtIds.length === 0)).map(shirt =>
                  <Select.Option key={shirt._id} value={shirt._id} disabled={shirt.quantity && shirt.count >= shirt.quantity}>
                    {shirt.name[locale]}
                  </Select.Option>
                )}
              </Select>
            )}
          </Form.Item>
        )
      }
      const couponCodeText = getFieldValue(
        `tickets[${groupIndex}].couponCodeText`
      )
      getFieldDecorator(`tickets[${groupIndex}].couponCodeId`)
      getFieldDecorator(`tickets[${groupIndex}].__couponCodeInfo`)
      const couponCodeInfo = getFieldValue(
        `tickets[${groupIndex}].__couponCodeInfo`
      )
      // console.log('selectedTicketType', group, groupIndex, selectedTicketType)
      // [`tickets[${groupIndex}].options`]
      // const couponCodeInfo = couponCodeText
      // console.log({ participant })
      const couponCodeEnabled = _get(event, 'settings.couponCode.enabled')
      const deliveryOption = _get(selectedTicketType, 'deliveryOption', 'none') || 'none'
      // console.log({ deliveryOption })
      const noDelivery = deliveryOption === 'none'
      // console.log({ selectedTicketType, deliveryOption, noDelivery })
      const deliveryRequired = deliveryOption === 'required'
      const deliveryDecorator = getFieldDecorator(`tickets[${groupIndex}].delivery`, {
        // valuePropName: 'checked',
        initialValue: deliveryRequired || _get(
          participant,
          `tickets[${groupIndex}].delivery`
        ),
        rules: [{ required: !noDelivery }] // [{ required: true }] // [{ required: deliveryRequired }]
      })
      const deliverySelected = getFieldValue(`tickets[${groupIndex}].delivery`)
      const reservedNumbers = _get(event, 'settings.ticket.reservedNumbers')
      const reservedNumbersTaken = _get(event, 'reservedNumbersTaken', [])
      // console.log({ reservedNumbersTaken })
      // const ticketsQuota = _get(event, 'ticketsQuota', [])
      // const ticketLimitReached = ticketsQuota.reduce((result, rec) => {
      //   result[rec._id] = rec.limit > 0 && rec.count >= rec.limit
      //   return result
      // }, {})

      return <Input.Group key={`group_${group}`}>
        <Form.Item
          label={group !== 'null' ? group : { en: 'Race', th: 'ประเภทการแข่งขัน' }[locale]}
          extra={selectedTicketType &&
            <span>{{ en: 'Category', th: 'รุ่นอายุ' }[locale]}:&nbsp;
              {this.ageCategoryString(
                getAgeCategory({
                  race: selectedTicketType.race,
                  birthDate,
                  gender
                })
              )}
            </span>
          }
          {...inputCols}
        >
          {/* ticketTypeDecorator(
                  <Radio.Group key={group} onChange={() => resetQuestions()}>
                    {ticketGroups[group].map(ticketType => (
                      <Radio.Button key={ticketType._id} value={ticketType._id}>
                        {ticketType.name[locale]}
                      </Radio.Button>
                    ))}
                  </Radio.Group>,
                ) */}
          {ticketTypeDecorator(<Select key={group} onChange={resetQuestions} defaultActiveFirstOption getPopupContainer={() => this.modalRef}>
            {_sortBy(ticketGroups[group], ['order'])
              .filter(ticketTypeAgeFilter)
              .filter(ticketTypePeriodFilter)
              .map(ticketType => {
                const ticketTypeFull = ticketType.quantity > 0 && _get(ticketTypeIdCount.find(c => c._id === ticketType._id), 'count', 0) >= ticketType.quantity
                // const limitReached = ticketType.limitId && ticketLimitReached[ticketType.limitId]
                const full = ticketTypeFull && !registrationType.hidden
                // const full = ticketTypeFull || limitReached
                // const full = ticketType.quantity > 0 && _get(ticketTypeIdCount.find(c => c._id === ticketType._id), 'count', 0) >= ticketType.quantity
                return <Select.Option
                  key={ticketType._id}
                  value={ticketType._id}
                  disabled={full}
                >
                  {(ticketType.price !== null) && <Tag color="blue">{ticketType.price} THB</Tag>}
                  {full && <Tag color="red">
                    {{ en: 'Full', th: 'เต็ม' }[locale]}
                  </Tag>}
                  {ticketType.name[locale]}
                </Select.Option>
              }
              )}
          </Select>)}
          {selectedTicketType &&
            <div style={{ whiteSpace: 'pre-line' }}>
              {_get(selectedTicketType, ['customMessage', locale])}
            </div>
          }
        </Form.Item>
        {selectedTicketType && selectedTicketType.reserveNumber && <Form.Item label={{ en: 'BIB Number', th: 'เบอร์วิ่ง' }[locale]} {...inputCols}>
          {getFieldDecorator(`tickets[${groupIndex}].reservedNumber`, {
            initialValue: `${_get(participant, `tickets[${groupIndex}].reservedNumber`, '')}`, // TODO: only !editMode
            rules: [
              {
                pattern: /^\d+$/,
                message: 'Please enter digits only'
              },
              {
                validator: this.reservedNumberValidator
              },
              {
                required: true,
                message: requiredFieldMessage
              }
            ]
          })(<Select
            showSearch
          >
            {reservedNumbers.map(number =>
              <Select.Option value={leftPad(`${number}`, 4, '0')} key={number} disabled={reservedNumbersTaken.includes(number)}>
                {leftPad(`${number}`, 4, '0')}
              </Select.Option>
            )}
          </Select>)}
        </Form.Item>}
        {regFields['nameOnBib'] && <Form.Item label={{ en: 'Name on BIB', th: 'ชื่อบนเบอร์วิ่ง' }[locale]} {...inputCols}>
          {getFieldDecorator(`tickets[${groupIndex}].nameOnBib`, {
            initialValue: _get(
              participant,
              `tickets[${groupIndex}].nameOnBib`
            ),
            rules: getRules(regFields['nameOnBib'])
          })(<Input />)}
        </Form.Item>}
        {shirtTypes.length > 0 && shirtEnabled && $shirtTypes}
        {shirtTypeId && shirtEnabled && $shirts}
        {selectedTicketType && !noDelivery &&
          <Form.Item key="delivery" label={{ en: 'Race Pack Collection', th: selectedTicketType.deliveryPrice > 0 ? 'รับเสื้อและเบอร์วิ่ง' : 'รับเสื้อ' }[locale]} {...inputCols}>
            {deliveryDecorator(
              <Radio.Group>
                <Radio value={true}><Tag color="blue">+{selectedTicketType.deliveryPrice} THB</Tag>{{ en: 'Post Delivery', th: `ทางไปรษณีย์ ${selectedTicketType.deliveryPrice > 0 ? '(มีค่าจัดส่งเพิ่มเติม/ชิ้น)' : ''}` }[locale]}</Radio>
                {deliveryOption === 'optional' && <Radio value={false}>{{ en: 'Collect by yourself', th: 'รับด้วยตนเองในวันงาน' }[locale]}</Radio>}
              </Radio.Group>
            )}
            {/* deliveryDecorator(<Checkbox disabled={deliveryRequired} ><Tag color="blue">{selectedTicketType.deliveryPrice} THB</Tag></Checkbox>) */}
          </Form.Item>
        }
        {deliverySelected && [
          <Form.Item key="recipient" label={{ en: 'Recipient', th: 'ชื่อผู้รับ' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.recipient`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.recipient`
              )
            })(
              <Input />
            )}
          </Form.Item>,
          <Form.Item key="street" label={{ en: 'Address', th: 'ที่อยู่' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.street`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.street`
              )
            })(
              <Input />
            )}
          </Form.Item>,
          <Form.Item key="locality" label={{ en: 'Locality', th: 'ตำบล/แขวง' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.locality`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.locality`
              )
            })(
              <Input />
            )}
          </Form.Item>,
          <Form.Item key="city" label={{ en: 'City', th: 'อำเภอ/เขต' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.city`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.city`
              )
            })(
              <Input />
            )}
          </Form.Item>,
          <Form.Item key="region" label={{ en: 'Province', th: 'จังหวัด' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.region`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.region`
              )
            })(
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0}
              >
                {provinces.map(province =>
                  <Select.Option
                    key={province.name.en}
                    value={province.name.en}
                  >
                    {province.name[locale]}
                  </Select.Option>
                )}
              </Select>
            )}
          </Form.Item>,
          <Form.Item key="postalCode" label={{ en: 'Postal Code', th: 'รหัสไปรษณีย์' }[locale]} {...inputCols}>
            {getFieldDecorator(`tickets[${groupIndex}].deliverTo.postalCode`, {
              rules: [{ required: true }],
              initialValue: _get(
                participant,
                `tickets[${groupIndex}].deliverTo.postalCode`
              )
            })(
              <Input />
            )}
          </Form.Item>
        ]}
        {$ticketQuestions}
        {couponCodeEnabled && <Form.Item label={{ en: 'Code', th: 'Code' }[locale]} {...inputCols} extra={couponCodeInfo}>
          <Row gutter={8}>
            <Col span={18}>
              {getFieldDecorator(
                `tickets[${groupIndex}].couponCodeText`,
                {
                  validateTrigger: [],
                  rules: [
                    {
                      validator: this.couponCodeValidator
                    }
                  ],
                  onChange: () =>
                    this.handleCouponCodeTextChange({
                      groupIndex
                    })
                }
              )(<Input />)}
            </Col>
            <Col span={6}>
              <Button disabled={!couponCodeText} onClick={e => this.checkCouponCode(
                { groupIndex }
              )}>
                    Check
              </Button>
            </Col>
          </Row>
        </Form.Item>}
      </Input.Group>
    })

    return (
      <Modal
        maskClosable={false}
        visible={visible}
        title={editMode
          ? ({
            en: `Edit Participant #${participantOrder} - ${registrationType.name[locale]}`,
            th: `แก้ไขผู้เข้าแข่งขันคนที่ ${participantOrder} - ${registrationType.name[locale]}`
          })[locale]
          : ({
            en: `Participant #${participantOrder} - ${registrationType.name[locale]}`,
            th: `ผู้เข้าแข่งขันคนที่ ${participantOrder} - ${registrationType.name[locale]}`
          })[locale]}
        onOk={handleSubmit}
        onCancel={this.onClose}
      >
        <div ref={ref => { this.modalRef = ref }} >
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col sm={{ span: 24 }}>
                <Input.Group key={`profile`}>
                  {regFields['firstName'] &&
                  <Form.Item
                    label={{ en: 'First Name', th: 'ชื่อ' }[locale]}
                    {...inputCols}
                    // hasFeedback
                  >
                    {getFieldDecorator(`profile.firstName`, {
                      initialValue: _get(participant, 'profile.firstName'),
                      rules: getRules(regFields['firstName'])
                    })(<Input key={`firstName`} />)}
                  </Form.Item>
                  }
                  {regFields['lastName'] &&
                  <Form.Item
                    label={{ en: 'Last Name', th: 'สกุล' }[locale]}
                    {...inputCols}
                    // hasFeedback
                  >
                    {getFieldDecorator(`profile.lastName`, {
                      initialValue: _get(participant, 'profile.lastName'),
                      rules: getRules(regFields['lastName'])
                    })(<Input key={`lastName`} />)}
                  </Form.Item>
                  }
                  <Form.Item
                    label={{ en: 'Gender', th: 'เพศ' }[locale]}
                    {...inputCols}
                  // hasFeedback
                  >
                    {genderDecorator(
                      <Radio.Group key={`gender`}>
                        <Radio.Button key="male" value="male" disabled={restrictions.includes('gender_female')}>
                          <Icon type="man" /> {{ en: 'Male', th: 'ชาย' }[locale]}
                        </Radio.Button>
                        <Radio.Button key="female" value="female" disabled={restrictions.includes('gender_male')}>
                          <Icon type="woman" />{' '}
                          {{ en: 'Female', th: 'หญิง' }[locale]}
                        </Radio.Button>
                      </Radio.Group>
                    )}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Birth Date', th: 'วัน เดือน ปี เกิด' }[locale]}
                    {...inputCols}
                  // hasFeedback
                  >
                    {birthDateDecorator(<DatePickerDropDown />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Email', th: 'อีเมล' }[locale]}
                    {...inputCols}
                  // hasFeedback
                  >
                    {getFieldDecorator(`profile.email`, {
                      initialValue: _get(participant, 'profile.email'),
                      rules: [{
                        type: 'email',
                        message: 'The input is not valid E-mail!'
                      }, {
                        required: true,
                        message: requiredFieldMessage
                      }, {
                        validator: this.emailValidator
                      }]
                    })(<Input key={`email`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Telephone', th: 'โทรศัพท์' }[locale]}
                    {...inputCols}
                  // hasFeedback
                  >
                    {getFieldDecorator(`profile.telephone`, {
                      initialValue: _get(participant, 'profile.telephone'),
                      rules: [
                        {
                        // pattern: /^[+][0-9]+?$|^[0-9]+?$/,
                          pattern: /^[0-9]{10,14}$/,
                          required: true,
                          message: intl.formatMessage({ id: 'app.incorrectPhone', defaultMessage: 'Please enter valid telephone number' })
                        }
                      ]
                    })(<Input key={`telephone`} />)}
                  </Form.Item>
                  {regFields['club'] &&
                  <Form.Item
                    label={{ en: 'Group/Club', th: 'กลุ่ม/ชมรม' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.club`, {
                      initialValue: _get(participant, 'profile.club'),
                      rules: [{ required: _get(regFields, 'club.required'),
                        message: requiredFieldMessage }]
                    })(<Input />)}
                  </Form.Item>
                  }
                  {regFields['nationalId'] &&
                  <Form.Item
                    label={{ en: 'National ID / Passport ID', th: 'เลขประจำตัวประชาชน' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.nationalId`, {
                      initialValue: _get(participant, 'profile.nationalId'),
                      rules: [{ required: _get(regFields, 'nationalId.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  }
                  {regFields['street'] &&
                  <Form.Item
                    label={{ en: 'Address', th: 'ที่อยู่' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.street`, {
                      initialValue: _get(participant, 'profile.street'),
                      rules: [{ required: _get(regFields, 'street.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  }
                  {regFields['locality'] &&
                  <Form.Item
                    label={{ en: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.locality`, {
                      initialValue: _get(participant, 'profile.locality'),
                      rules: [{ required: _get(regFields, 'locality.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  }
                  {regFields['city'] &&
                  <Form.Item
                    label={{ en: 'City', th: 'อำเภอ/เขต' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.city`, {
                      initialValue: _get(participant, 'profile.city'),
                      rules: [{ required: _get(regFields, 'city.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  }
                  {regFields['province'] &&
                  <Form.Item
                    label={{ en: 'Province of Residence', th: 'จังหวัดที่พักอาศัย' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.province`, {
                      initialValue: _get(participant, 'profile.province'),
                      rules: [{ required: _get(regFields, 'province.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  }
                  {regFields['country'] &&
                  <Form.Item
                    label={{ en: 'Country of Residence', th: 'ประเทศที่พักอาศัย' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.country`, {
                      initialValue: _get(participant, 'profile.country'),
                      rules: [{ required: _get(regFields, 'country.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .startsWith(input.toLowerCase())}
                      >
                        {countries.map(country =>
                          <Select.Option
                            key={country}
                            value={country}
                          >
                            {country}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
                  }
                  {regFields['nationality'] &&
                  <Form.Item
                    label={{ en: 'Nationality', th: 'สัญชาติ' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator(`profile.nationality`, {
                      initialValue: _get(participant, 'profile.nationality'),
                      rules: [{ required: _get(regFields, 'nationality.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .startsWith(input.toLowerCase())}
                      >
                        {nationalities.map(nationality =>
                          <Select.Option key={nationality} value={nationality}>
                            {nationality}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
                  }
                  {regFields['taxInvoice'] &&
                  <Form.Item
                    label={{ en: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                    {...inputCols}
                  >
                    {taxInvoiceTypeDecorator(
                      <Select>
                        {[{
                          _id: 'none',
                          en: 'None',
                          th: 'ไม่ขอใบกำกับภาษี'
                        }, {
                          _id: 'individual',
                          en: 'Individual',
                          th: 'บุคคล'
                        }, {
                          _id: 'company',
                          en: 'Company',
                          th: 'บริษัท'
                        }].map(option => (
                          <Select.Option key={option._id} value={option._id}>
                            {option[locale]}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>}
                  {regFields['taxInvoice'] &&
                taxInvoiceType !== 'none' && [
                    <Form.Item
                      label={
                        { en: 'Tax ID', th: 'หมายเลขประจำตัวผูเสียภาษี' }[locale]
                      }
                      key="taxId"
                      {...inputCols}
                    >
                      {getFieldDecorator(`profile.taxInvoice.taxId`, {
                        initialValue: _get(
                          participant,
                          'profile.taxInvoice.taxId'
                        ),
                        rules: [{
                          pattern: /^[0-9]{13,13}$/,
                          required: taxInvoiceType !== 'none',
                          message: intl.formatMessage({ id: 'app.incorrectTaxId', defaultMessage: 'Please enter valid tax ID' })
                        }]

                      })(<Input />)}
                    </Form.Item>,
                    <Form.Item
                      label={{ en: 'Address', th: 'ที่อยู่' }[locale]}
                      key="address"
                      {...inputCols}
                    >
                      {getFieldDecorator(`profile.taxInvoice.address`, {
                        initialValue: _get(
                          participant,
                          'profile.taxInvoice.address'
                        )
                      })(<Input type="textarea" />)}
                    </Form.Item>
                  ]}
                  {regFields['healthIssues'] &&
                  <Form.Item
                    label={{ en: 'Health Issues', th: 'ปัญหาสุขภาพ' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.healthIssues', {
                      initialValue: _get(
                        participant,
                        'profile.healtIssues'
                      ),
                      rules: [{ required: _get(regFields, 'healthIssues.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input.TextArea />
                    )}
                  </Form.Item>
                  }
                  {regFields['allergies'] &&
                  <Form.Item
                    label={{ en: 'Allergies', th: 'ภูมิแพ้' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.allergies', {
                      initialValue: _get(
                        participant,
                        'profile.allergies'
                      ),
                      rules: [{ required: _get(regFields, 'allergies.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input.TextArea />
                    )}
                  </Form.Item>
                  }
                  {regFields['bloodType'] &&
                  <Form.Item
                    label={{ en: 'Blood Type', th: 'หมู่เลือด' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.bloodType', {
                      initialValue: _get(
                        participant,
                        'profile.bloodType'
                      ),
                      rules: [{ required: _get(regFields, 'bloodType.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Select>
                        {bloodTypes.map(bloodType =>
                          <Select.Option
                            key={bloodType}
                            value={bloodType}
                          >
                            {bloodType}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
                  }
                  {regFields['emergencyContact'] &&
                  [<Form.Item
                    key="name"
                    label={{ en: 'Emergency Contact Person', th: 'ชื่อผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.emergencyContact.name', {
                      initialValue: _get(
                        participant,
                        'profile.emergencyContact.name'
                      ),
                      rules: [{ required: _get(regFields, 'emergencyContact.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>,
                  <Form.Item
                    key="relationship"
                    label={{ en: 'Contact Relationship', th: 'ความสัมพันธ์' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.emergencyContact.relationship', {
                      initialValue: _get(
                        participant,
                        'profile.emergencyContact.relationship'
                      ),
                      rules: [{ required: _get(regFields, 'emergencyContact.required'),
                        message: requiredFieldMessage }]
                    })(
                      <Input />
                    )}
                  </Form.Item>,
                  <Form.Item
                    key="phone"
                    label={{ en: 'Emergency Phone Number', th: 'เบอร์โทรกรณีฉุกเฉิน' }[locale]}
                    {...inputCols}
                  >
                    {getFieldDecorator('profile.emergencyContact.phone', {
                      initialValue: _get(
                        participant,
                        'profile.emergencyContact.phone'
                      ),
                      rules: [{
                        pattern: /^[+][0-9]+?$|^[0-9]+?$/,
                        required: _get(regFields, 'emergencyContact.required'),
                        message: intl.formatMessage({ id: 'app.incorrectPhone', defaultMessage: 'Please enter valid telephone number' })
                      }]
                    })(
                      <Input />
                    )}
                  </Form.Item>
                  ]}
                </Input.Group>
              </Col>
              <Col sm={{ span: 24 }}>
                <Input.Group key={`tickets`}>
                  {$ticketGroups}
                </Input.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    )
  }
}

export default compose(
  Form.create(),
  withRouter,
  withApollo,
  inject('i18n'),
  observer,
  graphql(participantQuery, {
    options: ({ participantId }) => ({
      skip: !participantId || participantId === 'new',
      variables: { _id: participantId }
    })
  }),
  graphql(createParticipantMutation, {
    name: 'createParticipant'
  }),
  graphql(updateParticipantMutation, {
    name: 'updateParticipant'
  }),
  injectIntl
)(ParticipantEditModal)



// WEBPACK FOOTER //
// ./src/App/components/ParticipantEditModal/ParticipantEditModal.js